export default theme => ({
  blockContainer: {
    height: '100%',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '1400px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      backgroundImage: 'none !important',
      backgroundColor: theme.palette.purple.main,
      position: 'relative',
      height: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
    },
  },
  content: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    maxWidth: '100%',
    height: '100%',
    width: '100%',
  },

  logo: {
    position: 'absolute',
    top: '5%',
    left: '15%',
    width: '10%',
    maxWidth: 150,
    [theme.breakpoints.down('md')]: {
      left: theme.spacing(4),
      top: theme.spacing(4),
    },
  },
  btn: {
    position: 'absolute',
    bottom: '10%',
    left: '15%',
    [theme.breakpoints.down('md')]: {
      left: theme.spacing(4),
      bottom: theme.spacing(4),
    },
  },
  topRightMention: {
    position: 'absolute',
    fontSize: '26px',
    letterSpacing: '4px',
    top: '5%',
    right: '14%',
    '& .light': {
      fontWeight: 300,
    },
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(4),
      right: theme.spacing(4),
    },
  },
  main: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '& img': {
      width: 'auto',
      height: '50vh',
      maxHeight: '70vh',
      maxWidth: '70vw',
      objectFit: 'contain',
    },
    [theme.breakpoints.down('md')]: {
      left: '50%',
    },
  },
});
